import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { message, Table, Typography } from "antd";
import { api } from "../../api/api";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";
import { CashTransfer } from "../../types/cashTransfer.type";

const { Title } = Typography;

export default function Commissions() {
  const { startDate, endDate } = useParams();
  const [commisions, setCommisions] = useState<CashTransfer[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchCommisions = async () => {
    setLoading(true);

    try {
      const response = await api.get(`/stats/commisions`, {
        params: {
          startDate,
          endDate,
        },
      });

      setCommisions(response.data);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение данных.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommisions();
  }, [startDate, endDate]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Клиент",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Сумма",
      dataIndex: "commission",
      key: "commission",
      render: (amount: number) => roundToThreeDecimals(amount),
    },
    {
      title: "Общ.Прибыль до",
      dataIndex: "netProfitBefore",
      key: "netProfitBefore",
      render: (data: number) => roundToThreeDecimals(data),
    },
    {
      title: "Общ.Прибыль после",
      dataIndex: "netProfitAfter",
      key: "netProfitAfter",
      render: (data: number) => roundToThreeDecimals(data),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>
        Комиссия {startDate} - {endDate}
      </Title>

      <Table
        loading={loading}
        columns={columns}
        dataSource={commisions}
        rowKey={(record) => record._id}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
